<template>
    <div class="nsp-entity d-flex align-items-center">
        <span>{{ entity.name }}</span>

        <b-button-group size="sm" class="ml-auto">
            <b-button variant="outline-secondary" v-on:click="$emit('up', entity)">
                <i class="icon-arrow-up"></i>
            </b-button>
            <b-button variant="outline-secondary" v-on:click="$emit('stop', entity)">
                <i class="icon-control-pause"></i>
            </b-button>
            <b-button variant="outline-secondary" v-on:click="$emit('down', entity)">
                <i class="icon-arrow-down"></i>
            </b-button>
        </b-button-group>
    </div>
</template>

<script>
export default
{
    name: 'ShutterRow',
    props:
    {
        entity:
        {
            type: Object,
            required: true,
        },
    },
};
</script>
